import { useSetRecoilState } from "recoil";
import { authAtom } from "../../recoil/atoms";
import { useMutation } from "react-query";
import { register } from "../../api/auth";
import { useNavigate } from "react-router-dom";
import jwtDecode from "jwt-decode";
import client from "../../api/client";

export const YEARS = [];
const nowYear = new Date().getFullYear();
for (let i = 1950; i <= nowYear; i++) {
  let y = String(i).padStart(2, "0");
  YEARS.push(y);
}

export const MONTHS = [];
for (let i = 1; i <= 12; i++) {
  let m = String(i).padStart(2, "0");
  MONTHS.push(m);
}

export const DAYS = [];
for (let i = 1; i <= 31; i++) {
  let d = String(i).padStart(2, "0");
  DAYS.push(d);
}

export const useRegister = () => {
  const navigate = useNavigate();
  const setAuthAtom = useSetRecoilState(authAtom);
  const onError = ({
    response: {
      status,
      data: { message },
    },
  }) => {
    if (status === 400) {
      alert(message);
    } else {
      alert("회원가입에 실패했습니다. 다시 진행해주세요");
    }

    window.location.href = "/login";
  };
  const onSuccess = ({ data: { accessToken } }) => {
    setAuthAtom({
      isLoggedIn: true,
      username: jwtDecode(accessToken).user.username,
      name: jwtDecode(accessToken).user.name,
    });
    client.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
    navigate("/");
  };
  return useMutation(register, {
    onError,
    onSuccess,
  });
};
